import PageHeader from '../../components/PageHeader/PageHeader';
import "../Style/style.css";
import { Row, Col, Form, Input, Tabs, Divider, Checkbox, Select, Upload, Button } from 'antd';
import { ReadCookie } from '../../utils/readCookie';
import { useRef, useState, useEffect, useLayoutEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import notification from '../../utils/notification'
import '../User/user.css'
import { SearchOutlined, FilterFilled, UploadOutlined } from '@ant-design/icons';
import { getSku } from "../../redux/actions/sku.action"
import '../salesPerson/saleperson.css'
import Loader from 'react-loader-spinner';
import '../Product/product.css'
import { TabTitle } from '../../utils/GeneralFunction';
import { addMultipleItemsCommunication } from '../../redux/actions/item.action';

const { TabPane } = Tabs;
const { Option } = Select;





const ProductCertificate = ({ token }) => {
    TabTitle("Product Certificate")

    const id = ReadCookie('menuId');
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState('view');
    const { users, module, menuRights, userRights, userDepartment, Sku } = useSelector(state => state);
    const moduleNameInput = useRef(null);
    const userNameInput = useRef(null);

    const [loading, setLoading] = useState(false);






    const onFinish = (values) => {

        setLoading(true);



        dispatch(addMultipleItemsCommunication(token, { sku: values.sku, file: values.file, remarks: values.remarks })).then((res) => {
            if (res.type === "ADD_MULTIPLE_ITEMS_COMMUNICATION_SUCCESS") {
                notification('success', 'Product Certificates', 'Product Certificates Uploaded Successfully!');
                form.setFieldsValue({ sku: null, file: null, remarks: null })
                setLoading(false);
            } else if (res.type === "") {
                notification('error', 'Product Certificates', 'Something went wrong!');
                setLoading(false);
            }
        })


    };

    const onFinishFailed = (errorInfo) => {
        console.log("Validation Failed:", errorInfo);
    };


    useEffect(() => {
        dispatch(getSku(token, null, null, null));
    }, [])


    return (
        <div className='styleContainer' >
            <div className='styleBody h-100' >
                <PageHeader title={"Add Product Certificates"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle'  >

                        <div style={{ padding: "10px 10px 0 10px" }} >
                            <Row>

                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <div className='styleForm'  >

                                        <div className='testStyle' >
                                            <Form
                                                form={form}
                                                name="basic"
                                                onFinish={onFinish}
                                                onFinishFailed={onFinishFailed}
                                            >

                                                <div className="customCols slc">
                                                    <div className='relative'>
                                                        <Form.Item
                                                            name="sku"
                                                            label="SKU"
                                                            labelAlign='left'
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Sku is required",
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                mode="multiple"
                                                                showSearch
                                                                // className="select_Inputs"
                                                                size="small"
                                                                optionFilterProp="children"
                                                                notFoundContent={
                                                                    Sku.loading ? (
                                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                            <Loader type="Oval" color="#3c4b58" height={20} width={20} />
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                            No Data
                                                                        </div>
                                                                    )
                                                                }
                                                                onChange={(values) => {
                                                                    console.log("Selected SKUs:", values);
                                                                    // Example: ["SKU001", "SKU002", "SKU003"]
                                                                }}
                                                            >
                                                                {Sku?.payload?.data?.map((it, index) => (
                                                                    <Option key={index} value={it.parent_item_id}>
                                                                        {it.sku}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>

                                                <div className="customCols slc">
                                                    <div className='relative'>
                                                        <Form.Item
                                                            name="remarks"
                                                            label="Remarks"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}

                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Remarks is required",
                                                                },
                                                            ]}
                                                        >
                                                            <Input placeholder='Enter Remarks' />
                                                        </Form.Item>
                                                    </div>
                                                </div>

                                                <div className="customCols slc">
                                                    <div className='relative'>
                                                        <Form.Item
                                                            name="file"
                                                            label="Upload File"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            valuePropName="fileList"
                                                            getValueFromEvent={(e) => {
                                                                if (Array.isArray(e)) {
                                                                    return e;
                                                                }
                                                                return e?.fileList;
                                                            }}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Please upload a file",
                                                                },
                                                            ]}
                                                        >
                                                            <Upload
                                                                beforeUpload={() => false}
                                                                maxCount={1}
                                                            >
                                                                <Button icon={<UploadOutlined />}>
                                                                    Select File
                                                                </Button>
                                                            </Upload>
                                                        </Form.Item>
                                                    </div>
                                                </div>

                                                <div style={{ display: "flex", justifyContent: "end", width: 420 }}>

                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        loading={loading}
                                                    >
                                                        Add Certificate
                                                    </Button>
                                                </div>


                                            </Form>
                                        </div>


                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </div>

                }
            </div>
        </div>


    )


}


export default ProductCertificate



